import { render, staticRenderFns } from "./rixin_admin.vue?vue&type=template&id=25759533&"
import script from "./rixin_admin.vue?vue&type=script&lang=js&"
export * from "./rixin_admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports